
const date = new Date();
export const actualDate = date.getFullYear() + '-' + 
      String(date.getMonth() + 1).padStart(2,'0') + '-' +
      String(date.getDate()).padStart(2,'0');